import { createContext } from 'utils/react-helpers';

const [RasterBranchesProvider, useRasterBranches] = createContext({
  name: 'RasterBranchesContext',
});

export { RasterBranchesProvider, useRasterBranches };
